import { AUDIO } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import VideoEditDrawer from '../video/video-edit-drawer';
import { EditProps } from './audio.constants';

const AudioSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <VideoEditDrawer {...props} />
  ) : (
    <StimulusLibrary
      title="Audio"
      stimulusType={AUDIO}
      componentId={props.id}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={AUDIO}
        />
      }
      {...props}
    />
  );
};

export default AudioSettings;
